import { keyframes } from '@emotion/react';
export var notificationExit = keyframes({
    from: {
        opacity: 1,
    },
    to: {
        opacity: 0,
    },
});
